import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template", "addButton"];
  static values = { max: { type: Number, default: 4 } };

  connect() {
    this.updateButtons();
  }

  addStat(event) {
    event.preventDefault();

    const statsCount =
      this.containerTarget.querySelectorAll(".key-stat-row").length;

    if (statsCount < this.maxValue) {
      const template = this.templateTarget.content.cloneNode(true);
      this.containerTarget.appendChild(template);
      this.updateButtons();
    }
  }

  removeStat(event) {
    event.preventDefault();

    const row = event.target.closest(".key-stat-row");
    const statsCount =
      this.containerTarget.querySelectorAll(".key-stat-row").length;

    if (row && statsCount > 1) {
      row.remove();
      this.updateButtons();
    }
  }

  updateButtons() {
    const statsCount =
      this.containerTarget.querySelectorAll(".key-stat-row").length;
    const removeButtons = this.containerTarget.querySelectorAll(
      '[data-action*="removeStat"]'
    );

    // Show/hide add button based on count
    if (this.hasAddButtonTarget) {
      if (statsCount >= this.maxValue) {
        // Remove display classes that conflict with hidden
        this.addButtonTarget.classList.remove("inline-flex");
        this.addButtonTarget.classList.add("hidden");
      } else {
        this.addButtonTarget.classList.remove("hidden");
        this.addButtonTarget.classList.add("inline-flex");
      }
    }

    // Show/hide remove buttons based on count
    removeButtons.forEach((button) => {
      if (statsCount <= 1) {
        button.classList.add("hidden");
      } else {
        button.classList.remove("hidden");
      }
    });
  }
}
